import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { DryerFilterTableComponent } from '../../../shared/component/dryer-filter-table/dryer-filter-table.component';
import { DynamicFormModelComponent } from '../../../shared/component/dynamic-form-model/dynamic-form-model.component';
import { DynamicFormComponent } from '../../../shared/component/dynamic-form/dynamic-form.component';

import { UnitConversionPipe } from '../../../shared/pipes/unit-conversion.pipe';
import { ProductContentComponent } from './product-content.component';

@NgModule({
  declarations: [ProductContentComponent, DryerFilterTableComponent, DynamicFormComponent, DynamicFormModelComponent, UnitConversionPipe],
  imports: [CommonModule, ReactiveFormsModule, MatTableModule, MatCheckboxModule, FormsModule, TranslateModule],
  exports: [ProductContentComponent, DryerFilterTableComponent],
})
export class ProductContentModule {}
